import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Lazy load page components for code splitting
const LandingPage = lazy(() => import('./components/pages/LandingPage'));
const ParentGuide = lazy(() => import('./components/pages/ParentGuide'));
const QuestLibrary = lazy(() => import('./components/pages/QuestLibrary'));
const NotFound = lazy(() => import('./components/pages/NotFound'));

// Loading fallback component
function LoadingFallback() {
  return (
    <div className="min-h-screen bg-background text-white flex items-center justify-center">
      <div className="text-center">
        <div className="animate-pulse text-accent text-xl">Loading...</div>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/guide" element={<ParentGuide />} />
          <Route path="/library" element={<QuestLibrary />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
